// editors_pick 카테고리 term_id 는 dev/운영 CMS 에서 다르다 (dev: 22, 운영: 162).
// CMS URL 기준으로 결정해 GraphQL 쿼리와 웹훅 term_id 매핑이 항상 대상 CMS 와 일치하도록 한다.
const EDITORS_PICK_TERM_ID =
  process.env.NEXT_PUBLIC_WORDPRESS_API_URL?.includes('cms.dev') ? 22 : 162;

// series 카테고리 term_id 도 dev/운영이 다르다 (dev: 17, 운영: 165).
const SERIES_TERM_ID = process.env.NEXT_PUBLIC_WORDPRESS_API_URL?.includes(
  'cms.dev',
)
  ? 17
  : 165;

// tag 카테고리 term_id 도 dev/운영이 다르다 (dev: 18, 운영: 166).
// 태그 유니버스는 카테고리 열거가 아니라 블로그 리스트 tags 합집합에서 오므로 CONTENT_CATEGORY_ID
// 에는 넣지 않고, 웹훅 카테고리 인식용 역방향 매핑(CONTENT_CATEGORY_LABEL)에만 등록한다.
const TAG_TERM_ID = process.env.NEXT_PUBLIC_WORDPRESS_API_URL?.includes(
  'cms.dev',
)
  ? 18
  : 166;

export const CONTENT_CATEGORY_ID = {
  blog: 7,
  news: 9,
  faq: 11,
  publications: 2,
  ir: 5,
  notice: 5,
  resources: 3,
  authors: 10,
  banner: 6,
  reanalysis: 123,
  editorsPick: EDITORS_PICK_TERM_ID,
  series: SERIES_TERM_ID,
} as const;

export const CONTENT_CATEGORY_LABEL: Record<string, string> = {
  '7': 'blog',
  '9': 'news',
  '11': 'faq',
  '2': 'publications',
  '5': 'ir', // notice
  '3': 'resources',
  '10': 'authors',
  '6': 'banner',
  '123': 'reanalysis',
  [EDITORS_PICK_TERM_ID]: 'editors_pick',
  [SERIES_TERM_ID]: 'series',
  [TAG_TERM_ID]: 'tag',
};

export type ContentCategoryId =
  (typeof CONTENT_CATEGORY_ID)[keyof typeof CONTENT_CATEGORY_ID];
